module.exports = __webpack_public_path__ + "img/21.e1202d20.jpg";